var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class UsageClient {
    constructor(httpClient, usageTelemetryConfig) {
        this.localStorageKey = '__Core.UserAttribute.UsageUserId__';
        this.sesionDurationConfig = '__Core.UserAttribute.sessionDurationConfig__';
        this.getUsageConfig = () => this.usageTelemetryConfig;
        this.usageTelemetryConfig = usageTelemetryConfig;
        this.httpClient = httpClient;
    }
    getUsageUserId() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    //TODO: ras1 => add redux support (06-20: Defered this from v3, as it involves, redux handles from client side)
                    let usageUserId = '';
                    if (this.usageTelemetryConfig.usageApi.cache ===
                        'localStorage') {
                        usageUserId = localStorage.getItem(this.localStorageKey);
                        localStorage.setItem(this.sesionDurationConfig, this.usageTelemetryConfig.sessionDurationMinutes.toString());
                    }
                    const invalidUserIds = [
                        '',
                        'NOTFOUND',
                        'NOTUPNFOUND',
                        'ERROR',
                        'UNDEFINED',
                        'UNINITIALIZED',
                    ];
                    if (usageUserId &&
                        invalidUserIds.indexOf(usageUserId.trim().toUpperCase()) < 0) {
                        resolve(usageUserId);
                    }
                    else {
                        const { data: content, } = yield this.httpClient.request({
                            url: this.usageTelemetryConfig.usageApi.url,
                            resource: this.usageTelemetryConfig.usageApi
                                .resourceId,
                            header: this.usageTelemetryConfig.usageApi
                                .headers,
                        }, { silentError: true });
                        if (content && content.UsageUserId) {
                            if (this.usageTelemetryConfig.usageApi.cache ===
                                'localStorage') {
                                localStorage.setItem(this.localStorageKey, content.UsageUserId);
                            }
                            resolve(content.UsageUserId);
                        }
                        else {
                            reject();
                        }
                    }
                }
                catch (_a) {
                    reject();
                }
            }));
        });
    }
}
//# sourceMappingURL=UsageClient.js.map